import dayjs from "dayjs"

export const calculateLastDays = (days: number) => {
  const endDate = dayjs()
  const startDate = endDate.subtract(days, "day")

  return [startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD")] as [string, string]
}
